import { pageTitleStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsPageTitle";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";
// EC-617 : Fixing css issues on PLP & PDP
pageTitleStyles.titleText = {
    variant: "h2",
    css: css`
        font-size: 24px;
        line-height: 30px;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    font-size: 20px;
                `,
                css`
                    font-size: 20px;
                `,
                css``,
                css``,
                css``,
            ])}
    `,
};
